export default {
  title: 'Technology',
  subtitle: 'Titron Technology Stack',
  description: 'Building next-generation privacy protection blockchain infrastructure based on advanced cryptographic technology and innovative consensus mechanisms',
  coreTech: {
    title: 'Core Technology',
    description: 'Based on the most advanced cryptographic technology, achieving true privacy protection',
    zkp: {
      title: 'Zero-Knowledge Proofs (ZKP)',
      subtitle: 'Zero-Knowledge Proofs',
      description: 'Prove the truth of a statement without revealing any information, achieving verifiable but invisible data',
      features: [
        'zk-SNARKs and zk-STARKs support',
        'Privacy-protected transaction verification',
        'Identity authentication without revealing identity',
        'Verifiable computing'
      ]
    },
    homomorphic: {
      title: 'Homomorphic Encryption',
      subtitle: 'Homomorphic Encryption',
      description: 'Allow direct computation on encrypted data without decryption first, supporting computation while protecting data privacy',
      features: [
        'Fully Homomorphic Encryption (FHE)',
        'Partially Homomorphic Encryption (PHE)',
        'Secure Multi-Party Computation',
        'Privacy-protected machine learning'
      ]
    },
    ringSignatures: {
      title: 'Ring Signature Technology',
      subtitle: 'Ring Signatures',
      description: 'Provide transaction sender anonymity, making it impossible to determine which specific user initiated the transaction',
      features: [
        'Sender anonymity',
        'Unlinkability',
        'Quantum-resistant',
        'Efficient signature verification'
      ]
    },
    mpc: {
      title: 'Decentralized Identity',
      subtitle: 'Decentralized Identity',
      description: 'Blockchain-based identity management system, users have complete control over their identity information and data authorization',
      features: [
        'Self-sovereign identity management',
        'Selective disclosure',
        'Cross-platform identity verification',
        'Data sovereignty control'
      ]
    }
  },
  consensus: {
    title: 'Consensus Mechanism',
    heading: 'Innovative Consensus Algorithm',
    description: 'Innovative consensus mechanism combining privacy protection and efficient verification',
    bft: {
      title: 'Enhanced Byzantine Fault Tolerance',
      subtitle: 'Enhanced BFT',
      description: 'Based on Byzantine fault tolerance consensus algorithm, providing fast transaction confirmation and high throughput',
      features: [
        'Fast transaction confirmation (2-3 seconds)',
        'High throughput (10,000+ TPS)',
        'Strong consistency guarantee',
        'Resistant to malicious node attacks'
      ]
    },
    pos: {
      title: 'Proof of Stake',
      subtitle: 'Proof of Stake',
      description: 'Consensus mechanism based on token holdings, energy-efficient, environmentally friendly and secure',
      features: [
        'Energy efficient and environmentally friendly',
        'Economic incentive alignment',
        'Long-term security',
        'Decentralized governance'
      ]
    }
  },
  specs: {
    title: 'Technical Specifications',
    heading: 'Technical Parameters',
    description: 'Technical specifications and performance metrics of the Titron network',
    network: {
      category: 'Network Performance',
      transactionTime: 'Transaction Confirmation Time',
      throughput: 'Throughput',
      blockTime: 'Block Time',
      latency: 'Network Latency',
      values: {
        transactionTime: '2-3 seconds',
        throughput: '10,000+ TPS',
        blockTime: '1 second',
        latency: '< 100ms'
      }
    },
    privacy: {
      category: 'Privacy Protection',
      zkProof: 'Zero-Knowledge Proof',
      homomorphic: 'Homomorphic Encryption',
      ringSignature: 'Ring Signature',
      privacyLevel: 'Privacy Level',
      values: {
        zkProof: 'zk-SNARKs/STARKs',
        homomorphic: 'Fully Homomorphic Encryption',
        ringSignature: 'Supported',
        privacyLevel: 'Complete Anonymity'
      }
    },
    development: {
      category: 'Development Support',
      smartContracts: 'Smart Contracts',
      programmingLanguages: 'Programming Languages',
      devTools: 'Development Tools',
      testnet: 'Test Network',
      values: {
        smartContracts: 'EVM + WASM',
        programmingLanguages: 'Solidity, Rust, Go',
        devTools: 'Complete SDK',
        testnet: 'Free to use'
      }
    }
  },
  innovation: {
    title: 'Innovation Highlights',
    heading: 'Technical Innovation',
    description: 'Titron\'s innovative breakthroughs in privacy protection technology',
    hybrid: {
      title: 'Hybrid Privacy Model',
      description: 'Combining multiple privacy technologies to provide comprehensive privacy protection'
    },
    scalable: {
      title: 'Scalable Architecture',
      description: 'Modular design supporting horizontal scaling and feature upgrades'
    },
    crosschain: {
      title: 'Cross-Chain Compatibility',
      description: 'Seamless integration and interoperability with mainstream blockchain networks'
    },
    developerFriendly: {
      title: 'Developer Friendly',
      description: 'Rich development tools and documentation, lowering development barriers'
    }
  },
  cta: {
    title: 'Start Using Titron Technology',
    description: 'Explore our technical documentation and start building privacy protection applications',
    button: 'Start Building',
    techDocs: 'Technical Documentation'
  }
};
